import { fetchApi } from '@/config/axiosSetting';
import { SingleWagesResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSingleWages/getSingleWagesQuery.type';

export const getSingleWagesQuery = ({
  id,
  damaged_id,
  wages_id,
}: {
  id: number;
  damaged_id: number;
  wages_id: number;
}): Promise<SingleWagesResponseType> =>
  fetchApi.get(
    `property/reports/${id}/accident_users/damaged/adjusting/wages/`,
    {
      params: {
        damaged_id,
        wages_id,
      },
    },
  );
